import { TAGS, api } from "@/store/api.ts"
import { setMaintenance } from "@/store/slices/app"
import { IMaintenanceResponse } from "."
import { socketMaintenance } from "./maintenance.socket"

const basePath = "/maintenance"

export const maintenanceApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.MAINTENANCE]
})

export const maintenanceEndpoints = maintenanceApi.injectEndpoints({
  endpoints: (builder) => ({
    getMaintenance: builder.query<IMaintenanceResponse, void>({
      query: () => ({
        url: `${basePath}`,
        method: "GET"
      }),
      providesTags: () => [{ type: TAGS.MAINTENANCE, id: `MAINTENANCE` }],
      async onCacheEntryAdded(
        _,
        { cacheDataLoaded, updateCachedData, cacheEntryRemoved, dispatch }
      ) {
        cacheDataLoaded.then(({ data }) => {
          dispatch?.(setMaintenance(data))
        })

        socketMaintenance.setUpdateData(updateCachedData)
        socketMaintenance.setDispatch(dispatch)

        socketMaintenance.init()
        socketMaintenance.addSub()

        const unsubscribeMaintenanceListener =
          socketMaintenance.bindMaintenanceListener()

        try {
          await cacheEntryRemoved
        } finally {
          unsubscribeMaintenanceListener?.()

          socketMaintenance.removeSub()
        }
      }
    })
  })
})

export const {
  useGetMaintenanceQuery,
  endpoints: { getMaintenance }
} = maintenanceEndpoints
